import { Config } from "../../core/config/config";
import { TextBox } from "../../core/components/textBox";
import { DropDownList } from "../../core/components/dropDownList";
import { FieldInstance } from "../../core/components/field";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Helper } from "../../core/util/helper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { SheetEventType } from "../../../siteManagement/sheet";
import { General } from "../../../siteManagement/general";
import React from "react";

export default class TranslationsLink extends React.Component<TranslationsLinkProps, TranslationsLinkState> {
    private _factory = ComponentHelper.createFactory();    
    private _translations: {} = null;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this._setEntity();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500

    };

    constructor(props) {
        super(props);
        this.state = { dialogOpen: false, language: null, values:[] };
    }

    private _setEntity = () => {
        let newEntity = this.props.entity;
        newEntity.GeneralSettings.ErweitertesLoginRegexDescriptionTranslations = this.state.values;
        Helper.updateEntity(this.props.entity, newEntity);
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.trigger(SheetEventType.Custom, { command: "setGeneralSettingsStateDirty"});
    }

    private _loadTranslations = () => {
        Helper.getTranslations(["Standard.TranslationLink", "Sprachen.Sprache"])
            .then((result) => {
                this._translations = result.Data;
                this.setState({});
        });
    }

    private _loadValues = () => {
        this.setState({ values: this.props.entity.GeneralSettings.ErweitertesLoginRegexDescriptionTranslations });
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this._createDropDownBox()}
                        {this._createTextBox()}
                    </FullHeightContainer>
                </Dialog>
            </div>
        );
    }

    private _createDropDownBox = () => {
        let props = this._factory.getDefaultDropDownProps();
        props.field.dataSourceUrl = "TranslationsView/GetLanguages";
        props.field.dataValueField = "Language";
        props.field.dataTextField = "Sprache";
        props.value = this.state.language;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {

            switch (typeof value) {
                case "number":
                    this.setState({ language: value });
                    break;
                default:
                    this.setState({ language: null });
                    break;
            }


        }

        return (
            <FieldInstance label={this._translations["Sprachen.Sprache"]} noHover={true} >
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    private _createTextBox = () => {
        if (Helper.hasValue(this.state.language)) {
            let props = this._factory.getDefaultTextBoxProps()
            props.field.multiLine = true;
            let val = this.state.values.filter(f => f.Key === this.state.language)[0];
            props.value = Helper.hasValue(val) ? Helper.getValueOrDefault(val.Value, '' ): '';
            props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                let id = 0;
                for (let i = 0; i < this.state.values.length; i++) {
                    if (this.state.values[i].Key === this.state.language) {
                        id = i;
                        break;
                    }
                }
                let values = this.state.values;
                values[id].Value = value;
                this.setState({ values: values });
            }

            return (
                <FieldInstance label={this._translations["Sprachen.Sprache"]} noHover={true} >
                    <TextBox {...props} />
                </FieldInstance>
            );
        } else {
            return (<></>);
        }


    }

    private _openDialog = () => {
        this.setState({ dialogOpen: true });
    }

    private _createLink = () => {
        const labelStyle: React.CSSProperties = {
            cursor: "pointer",
            textDecoration: "Underline"
        }

        const divStyle: React.CSSProperties = {
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "10px",
            marginTop: "2px"

        }
        return (
            <>
                <div style={divStyle}>
                    <label style={labelStyle} onClick={this._openDialog}>{this._translations["Standard.TranslationLink"]}</label>
                </div>

            </>
        );
    }

    componentDidMount() {
        this._loadValues();
        this._loadTranslations();
    }

    render() {
        const link = Helper.hasValue(this._translations) ? this._createLink() : <></>;
        const dialog = this.state.dialogOpen ? this._createDialog() : <></>;
        return (
            <>
                {link}
                {dialog}
            </>
        );
    }
}

interface TranslationsLinkProps {
    entity: any;
}

interface TranslationsLinkState {
    dialogOpen: boolean;
    language: number;
    values: Translations[];
}

interface Translations {
    Key: number;
    Value: number;
}